/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
        <div class="searchBox inpBox1">
          <div class="item">
            <el-form-item label="合同编号:" prop="contractNo">
              <el-input  placeholder="" v-model="searchFrom.contractNo"></el-input>
            </el-form-item>
            <!-- <el-form-item label="出租人甲方:" prop="leaseName">
              <el-input  placeholder="" v-model="searchFrom.leaseName"></el-input>
            </el-form-item> -->
            <el-form-item label="出租人甲方:" prop="leaseName">
            <el-select  v-model="searchFrom.leaseName"  value-key="id"  placeholder="请选择" filterable >
              <el-option v-for="(item,index) in SCList" :label="item.custerName" :value="item.custerName" :key="index"></el-option>
            </el-select>
            </el-form-item>
            <el-form-item label="承租人乙方:" prop="tenantryName">
            <el-select  v-model="searchFrom.tenantryName"  value-key="id"  placeholder="请选择" filterable >
              <el-option label="全部" value=""></el-option>
              <el-option v-for="(item,index) in CZList" :label="item.name" :value="item.name" :key="index"></el-option>
            </el-select>
            </el-form-item>
             <el-form-item label="状态:" prop="contractStatus">
              <el-select  v-model="searchFrom.contractStatus"   placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option label="未关联" value="1"></el-option>
                <el-option label="已关联" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="创建时间:" prop="createTime">
                <el-date-picker
                  v-model="searchFrom.createTime"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
         <el-form-item >
            <el-button type="primary" v-if="btnFlg[0]" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item  >
            <el-button type="primary"  v-if="btnFlg[1]"  @click="addRegion">新增</el-button>
          </el-form-item>
          <!-- <el-form-item  >
            <el-button type="primary"  v-if="btnFlg[5]"  @click="lookFn">查看合同</el-button>
          </el-form-item> -->
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作"  width="160">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="imgFn(scope.row)" v-if="btnFlg[4]">附件</el-button>
              <el-button type="text" size="mini" @click="editFn(scope.row)" v-if="scope.row.contractStatus == 1&&btnFlg[2]">修改</el-button>
              <el-button type="text" size="mini" @click="delFn(scope.row)" v-if="scope.row.contractStatus == 1&&btnFlg[3]">删除</el-button>
               <el-button type="text" size="mini" @click="detailFn(scope.row)" >详情</el-button>
            </template>
        </el-table-column>
        <!-- <el-table-column property="contractStatus" width="110" label="状态" >
          <template scope="scope">
            {{[ "未关联", "已关联" ][scope.row.contractStatus-1]}}
          </template>
        </el-table-column> -->
        <el-table-column prop="contractNo" min-width="170"  :formatter="emptyFn" label="合同编号"></el-table-column>
        <el-table-column prop="shipName" min-width="170"  :formatter="emptyFn" label="船舶名称"></el-table-column>
        <!-- <el-table-column label="系统合同编号" width="240">
          <template slot-scope="scope">
            <span style="color: #0c46a2;cursor: pointer;" @click="detailFn(scope.row)">{{scope.row.contractSysNo}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="leaseName"  min-width="200" :formatter="emptyFn" label="出租人甲方" show-overflow-tooltip></el-table-column>
        <el-table-column prop="tenantryName"  min-width="200" :formatter="emptyFn" label="承租人乙方" show-overflow-tooltip> </el-table-column>
        <el-table-column property="contractDraft" width="120" label="合同拟定方" >
            <template scope="scope">
              {{[ "甲方", "乙方" ][scope.row.contractDraft-1]}}
            </template>
          </el-table-column>
        <el-table-column prop="createUserName" width="140" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新建修改 -->
    <el-dialog  :title="title"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog"   :visible.sync="dialogVisible" width="1240px" center>
        <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="140px" size="mini">
        <div class="inpBox">
          <div class="addressBox">
            <h4 class="title">
              <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>合同信息</span>
            </h4>
          <div>
            <el-form-item label="合同编号:" prop="contractNo">
              <el-input  placeholder="" maxlength="25"  v-model="addFrom.contractNo" ></el-input>
            </el-form-item>
            <el-form-item label="合同拟定方:" prop="contractDraft">
              <el-select  v-model="addFrom.contractDraft" placeholder="请选择">
                <el-option v-for="item in ContractFormulation" :label="item.name" :value="item.value" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合同日期:" prop="contractTime"  class="inpBox2">
            <el-date-picker
              v-model="addFrom.contractTime"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
            <!-- <el-form-item label="邀标编号:" prop="contractNo1">
              <el-input  placeholder="" maxlength="20"  v-model="addFrom.contractNo1" ></el-input>
            </el-form-item> -->
            <div>
              <el-form-item label="出租人甲方:" prop="leaseName">
                <el-select  v-model="addFrom.leaseName"  value-key="id"  placeholder="请选择" filterable >
                  <el-option v-for="(item,index) in SCList" :label="item.custerName" :value="item.custerName" :key="index"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="税号:" prop="leaserTaxpayerNumber">
                <el-input  placeholder="" maxlength="20"  v-model="addFrom.leaserTaxpayerNumber" ></el-input>
              </el-form-item>
              <el-form-item label="银行账号:" prop="leaserBankAccount">
                <el-input  placeholder="" maxlength="24"  v-model="addFrom.leaserBankAccount" ></el-input>
              </el-form-item>
              <el-form-item label="行号:" prop="leaserBankNo">
                <el-input  placeholder="" maxlength="20"  v-model="addFrom.leaserBankNo" ></el-input>
              </el-form-item>
              <el-form-item label="承租人乙方:" prop="tenantryName">
                <el-select  v-model="addFrom.tenantryName"  placeholder="请选择" >
                  <el-option v-for="item in CZList" :label="item.name" :value="item.name" :key="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="电话传真:" prop="tenantryMobile">
                <el-input  placeholder="" maxlength="20"  v-model="addFrom.tenantryMobile" ></el-input>
              </el-form-item>
              <el-form-item label="开户银行:" prop="tenantryBankName">
                <el-input  placeholder="" maxlength="20"  v-model="addFrom.tenantryBankName" ></el-input>
              </el-form-item>
              <el-form-item label="银行账号:" prop="tenantryBankAccount">
                <el-input  placeholder="" maxlength="24"  v-model="addFrom.tenantryBankAccount" ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
        <hr>
        <div class="addressBox">
          <h4 class="title">
            <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>船舶信息</span>
          </h4>
        <div>
          <el-form-item label="船舶名称:" prop="shipName">
            <el-select  v-model="addFrom.shipName"  value-key="id"  placeholder="请选择" filterable @change="shipNameFn()">
              <el-option v-for="(item,index) in CBNameList" :label="item.shipName" :value="item.shipName" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="航次号:" prop="shipDateNo">
            <el-input  placeholder="" maxlength="20"  v-model="addFrom.shipDateNo" ></el-input>
          </el-form-item>
          <el-form-item label="总吨:" prop="shipFullDisplacement" class="jiage">
            <el-input  placeholder="" maxlength="20"  v-number-input.float="0" v-model="addFrom.shipFullDisplacement" ></el-input><span class="danwei">吨</span>
          </el-form-item>
          <el-form-item label="净吨:" prop="shipNoLoadDisplacement" class="jiage">
            <el-input  placeholder="" maxlength="20"  v-number-input.float="0" v-model="addFrom.shipNoLoadDisplacement" ></el-input><span class="danwei">吨</span>
          </el-form-item>
          <el-form-item label="总舱容:" prop="shipTotalLength" class="jiage">
            <el-input  placeholder="" maxlength="20"  v-model="addFrom.shipTotalLength" ></el-input><span class="danwei">米³</span>
          </el-form-item>
          <el-form-item label="载重吨:" prop="shipReferenceCapacity" class="jiage">
            <el-input  placeholder="" maxlength="20"  v-number-input.float="0" v-model="addFrom.shipReferenceCapacity" ></el-input><span class="danwei">吨</span>
          </el-form-item>
          <el-form-item label="舱口数:" prop="shipWarehouseQuantity" class="jiage">
            <el-input  placeholder="" maxlength="20"  v-number-input.float="0" v-model="addFrom.shipWarehouseQuantity" ></el-input><span class="danwei">个</span>
          </el-form-item>
          <el-form-item label="船长:" prop="shipLength" class="jiage">
            <el-input  placeholder="" maxlength="20"  v-number-input.float="2" v-model="addFrom.shipLength" ></el-input><span class="danwei">米</span>
          </el-form-item>
          <el-form-item label="船宽:" prop="shipWidth" class="jiage">
            <el-input  placeholder="" maxlength="20"  v-number-input.float="2" v-model="addFrom.shipWidth" ></el-input><span class="danwei">米</span>
          </el-form-item>
          <el-form-item label="满载吃水:" prop="shipFullDraft" class="jiage">
            <el-input  placeholder="" maxlength="20"  v-number-input.float="3" v-model="addFrom.shipFullDraft" ></el-input><span class="danwei">米</span>
          </el-form-item>
        </div>
        </div>
        <hr>
        <div class="addressBox">
          <h4 class="title">
            <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>货费信息</span>
          </h4>
        <div>
          <el-form-item label="货名:" prop="goodsName" >
            <el-input  placeholder="" maxlength="20" v-model="addFrom.goodsName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="重量:" prop="contractWeight" class="jiage">
            <el-input  placeholder="" maxlength="20"  v-number-input.float="0" v-model="addFrom.contractWeight" ></el-input><span class="danwei">吨</span>
          </el-form-item>
         <el-form-item label="计价方式:" prop="pricingMethod" class="jiage">
            <el-select  v-model="addFrom.pricingMethod"  placeholder="请选择" >
              <el-option v-for="val in pricingMethods" :label="val.name" :value="val.val" :key="val.val"></el-option>
            </el-select>
          </el-form-item>
          <div>
            <el-form-item label="一港价格:" prop="freightMoney">
              <el-input  placeholder="" maxlength="20"  v-number-input.float="2" v-model="addFrom.freightMoney" ></el-input>
            </el-form-item>
             <el-form-item label="两港价格:" prop="freightMoneyTwo">
              <el-input  placeholder="" maxlength="20"  v-number-input.float="2" v-model="addFrom.freightMoneyTwo" ></el-input>
            </el-form-item>
             <el-form-item label="一港含税:" prop="taxPrice">
              <el-input  placeholder="" maxlength="20"  v-number-input.float="2" v-model="addFrom.taxPrice" ></el-input>
            </el-form-item>
             <el-form-item label="两港含税:" prop="taxPriceTwo">
              <el-input  placeholder="" maxlength="20"  v-number-input.float="2" v-model="addFrom.taxPriceTwo" ></el-input>
            </el-form-item>
          </div>

          <el-form-item label="保底吨数:" class="jiage" prop="contractMinWeight">
            <el-input  placeholder=""  v-number-input.float="0"  maxlength="8" v-model="addFrom.contractMinWeight" ></el-input><span class="danwei">吨</span>
          </el-form-item>
          <el-form-item label="滞期费率:" class="jiage" prop="demurrageRate">
            <div style="display:flex">
              <el-input  placeholder=""  v-number-input.float="2"  maxlength="8" v-model="addFrom.demurrageRate" ></el-input>
              <el-form-item label="" prop="demurrageUnit" :class="['danwei1','inpBox4']">
                <el-select  v-model="addFrom.demurrageUnit" >
                  <el-option v-for="item in demurrageRateUnit" :label="item.name" :value="item.name" :key="item.value"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="装船期限:" class="jiage" prop="shipMentTime">
            <el-input  placeholder=""  v-number-input.float="0"  maxlength="8" v-model="addFrom.shipMentTime" ></el-input><span class="danwei">小时</span>
          </el-form-item>
          <el-form-item label="卸船期限:" class="jiage" prop="shipUnloadTime">
            <el-input  placeholder=""  v-number-input.float="0"  maxlength="8" v-model="addFrom.shipUnloadTime" ></el-input><span class="danwei">小时</span>
          </el-form-item>
          <el-form-item label="封航承担比例:" class="jiage" prop="closureRate">
            <el-input  placeholder=""  maxlength="8" @blur="effectiveTime()"  v-number-input.float="0" v-model="addFrom.closureRate" ></el-input><span class="danwei">%</span>
          </el-form-item>
          <el-form-item label="受载期限:" prop="loadTime"  class="inpBox2">
            <el-date-picker
              v-model="addFrom.loadTime"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="定金金额:" class="jiage" prop="earnestMoney">
            <el-input  placeholder=""  v-number-input.float="2"  maxlength="8" v-model="addFrom.earnestMoney" ></el-input><span class="danwei">元</span>
          </el-form-item>
          <el-form-item label="起始港口:" prop="deliverAddress" class="jiage" >
            <el-select  v-model="addFrom.deliverAddress"  value-key="id"  placeholder="请选择" filterable @change="qishiChange">
              <el-option v-for="(item,index) in MTList" :label="item.addressName" :value="item.addressName" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <div v-for="(i, index1) in addFrom.region" :key="index1" style="display: inline-block;margin-right: -40px">
          <el-form-item  :label="'目的港' + (index1 + 1) + ':'"  :prop="'region.' + index1 + '.receivingAddressName'+'.id'"  :key="index1" class="jiage" :rules="{required: true, message: '目的码头不能为空', trigger: 'blur' }">
              <el-select  v-model="i.receivingAddressName"  value-key="id"  placeholder="请选择" filterable  @change="mudiChange($event,index1)">
                <el-option v-for="(item) in MTList" :label="item.addressName" :value="item" :key="item.id"></el-option>
              </el-select>&nbsp;&nbsp;
              <span @click="add" v-if="index1 == addFrom.region.length - 1 && addFrom.region.length < 2"><i class="el-icon-circle-plus-outline"></i></span>&nbsp;&nbsp;
              <span @click="deleteItem(index1)" v-if="addFrom.region.length > 1"><i class="el-icon-delete"></i></span>
          </el-form-item>
          </div>
          </div>
          </div>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom',1)">保 存</el-button>
        <!-- <el-button type="primary" @click="saveFn('addFrom',2)">保存并打印</el-button> -->
      </span>
    </el-dialog>
      <!-- 详情 -->
    <el-dialog  :title="title"  :close-on-click-modal="false" :close-on-press-escape="false" class="detail"  @close="closeDialog"   :visible.sync="dialogDetail" width="1300px" center>
      <span>
         <el-form :inline="true" :model="addFromNew" ref="addFromNew" class="demo-form-inline" label-width="110px" size="mini">
        <div class="inpBox">
             <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>合同信息</span>
              </h4>
              <div>
                <div>
                  <el-form-item label="合同编号:" prop="contractNo" class="NOcommon">
                  <span>{{addFromNew.contractNo ? addFromNew.contractNo : '-'}}</span>
                  </el-form-item>
                  <el-form-item label="合同拟定方:" prop="contractDraft" class="NOcommon">
                  <span>{{addFromNew.contractDraft == 1 ? '甲方' : '乙方'}}</span>
                  </el-form-item>
                  <el-form-item label="合同日期:" prop="contractTime" >
                  <span>{{addFromNew.contractTime ? dateFormatUtil("yyyy-MM-dd", addFromNew.contractTime):'-'}}</span>
                  </el-form-item>
                  <!-- <el-form-item label="邀标编号:" prop="contractNo1" >
                  <span>{{addFromNew.contractNo1 ? addFromNew.contractNo1 : '-'}}</span>
                  </el-form-item> -->
                </div>
                <el-form-item label="出租人甲方:" prop="leaseName" class="NOcommon">
                  <span>{{addFromNew.leaseName}}</span>
                </el-form-item>
                <el-form-item label="税号:" prop="leaserTaxpayerNumber">
                  <span>{{addFromNew.leaserTaxpayerNumber ? addFromNew.leaserTaxpayerNumber : '-'}}</span>
                </el-form-item>
                <el-form-item label="银行账号:" prop="leaserBankAccount">
                  <span>{{addFromNew.leaserBankAccount ? addFromNew.leaserBankAccount : '-'}}</span>
                </el-form-item>
                <el-form-item label="行号:" prop="leaserBankNo">
                  <span>{{addFromNew.leaserBankNo ? addFromNew.leaserBankNo : '-'}}</span>
                </el-form-item>
                <!-- <el-form-item label="承租人乙方:" prop="tenantryName" class="NOcommon">
                  <span>{{addFromNew.tenantryName == 1 ? '中物唐山曹妃甸区物流有限责任公司' : '中物(北京)物流信息服务有限公司唐山曹妃甸分公司'}}</span>
                </el-form-item> -->
                <el-form-item label="承租人乙方:" prop="tenantryName" class="NOcommon">
                  <span>{{addFromNew.tenantryName ? addFromNew.tenantryName : '-'}}</span>
                </el-form-item>
                <el-form-item label="电话传真:" prop="tenantryMobile">
                  <span>{{addFromNew.tenantryMobile ? addFromNew.tenantryMobile : '-'}}</span>
                </el-form-item>
                <el-form-item label="开户银行:" prop="tenantryBankName">
                  <span>{{addFromNew.tenantryBankName ? addFromNew.tenantryBankName : '-'}}</span>
                </el-form-item>
                <el-form-item label="银行账号:" prop="tenantryBankAccount">
                  <span>{{addFromNew.tenantryBankAccount ? addFromNew.tenantryBankAccount : '-'}}</span>
                </el-form-item>
              </div>
            </div>
            <hr>
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>船舶信息</span>
              </h4>
              <div>
              <el-form-item label="船舶名称:" prop="shipName" class="NOcommon">
                <span >{{addFromNew.shipName ? addFromNew.shipName : '-'}}</span>
              </el-form-item>
              <el-form-item label="航次号:" prop="shipDateNo" class="NOcommon">
                <span>{{addFromNew.shipDateNo}}</span>
              </el-form-item>
              <el-form-item label="总吨:" prop="shipFullDisplacement" class="jiage">
                <span >{{addFromNew.shipFullDisplacement ? addFromNew.shipFullDisplacement + ' 吨' : '-'}}</span>
              </el-form-item>
              <el-form-item label="净吨:" prop="" class="jiage">
                <span >{{addFromNew.shipNoLoadDisplacement ? addFromNew.shipNoLoadDisplacement + ' 吨' : '-'}} </span>
              </el-form-item>
              <el-form-item label="总舱容:" prop="shipTotalLength" class="jiage">
                <span >{{addFromNew.shipTotalLength ? addFromNew.shipTotalLength + ' 米³' : '-'}} </span>
              </el-form-item>
              <el-form-item label="载重吨:" prop="shipReferenceCapacity" class="jiage">
               <span >{{addFromNew.shipReferenceCapacity ? addFromNew.shipReferenceCapacity + ' 吨' : '-'}} </span>
              </el-form-item>
              <el-form-item label="舱口数:" prop="shipWarehouseQuantity" class="jiage">
                <span >{{addFromNew.shipWarehouseQuantity ? addFromNew.shipWarehouseQuantity + ' 个' : '-'}} </span>
              </el-form-item>
              <el-form-item label="船长:" prop="shipLength" class="jiage">
                <span >{{addFromNew.shipLength ? addFromNew.shipLength + ' 米' : '-'}} </span>
              </el-form-item>
              <el-form-item label="船宽:" prop="shipWidth" class="jiage">
                <span >{{addFromNew.shipWidth ? addFromNew.shipWidth + ' 米' : '-'}} </span>
              </el-form-item>
              <el-form-item label="满载吃水:" prop="shipFullDraft" class="jiage">
               <span >{{addFromNew.shipFullDraft ? addFromNew.shipFullDraft + ' 米' : '-'}} </span>
              </el-form-item>
              </div>
            </div>
            <hr>
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>船舶信息</span>
              </h4>
              <div>
                <!-- <el-form-item label="货名:" prop="goodsName" class="NOcommon">
                  <span>{{addFromNew.goodsName}}</span>
                </el-form-item> -->
                <el-form-item label="货名:" prop="goodsName" class="NOcommon">
                  <span>钢材</span>
                </el-form-item>
                <el-form-item label="重量:" prop="contractWeight" class="NOcommon">
                  <span>{{addFromNew.contractWeight ? addFromNew.contractWeight : '-'}}</span>
                </el-form-item>
                <el-form-item label="计价方式:" prop="pricingMethod" class="NOcommon">
                  {{[ "按吨", "包船" ][addFromNew.pricingMethod-1]}}
                </el-form-item>
              <br>
                 <el-form-item label="一港价格:" prop="freightMoney" >
                  <span>{{addFromNew.freightMoney?addFromNew.freightMoney:'-'}}</span>
                </el-form-item>
                <el-form-item label="两港价格:" prop="freightMoneyTwo" >
                  <span>{{addFromNew.freightMoneyTwo?addFromNew.freightMoneyTwo:'-'}}</span>
                </el-form-item>
                <el-form-item label="一港含税:" prop="taxPrice" >
                  <span>{{addFromNew.taxPrice ? addFromNew.taxPrice : '-'}}</span>
                </el-form-item>
                <el-form-item label="两港含税:" prop="taxPriceTwo" >
                  <span>{{addFromNew.taxPriceTwo ? addFromNew.taxPriceTwo : '-'}}</span>
                </el-form-item>
                <el-form-item label="保底吨数:" prop="contractMinWeight" class="NOcommon">
                  <span>{{addFromNew.contractMinWeight}} 吨</span>
                </el-form-item>
                <!-- <el-form-item label="滞期费率:" prop="demurrageRate" class="NOcommon">
                  <span>{{addFromNew.demurrageRate}} 元/天/吨</span>
                </el-form-item> -->
                <el-form-item label="滞期费率:" prop="demurrageRate" class="NOcommon">
                  <span>{{addFromNew.demurrageRate + ' ' + addFromNew.demurrageUnit}}</span>
                </el-form-item>
                <el-form-item label="装船期限:" prop="shipMentTime" class="NOcommon">
                  <span>{{addFromNew.shipMentTime}} 小时</span>
                </el-form-item>
                <el-form-item label="卸船期限:" prop="shipUnloadTime" class="NOcommon">
                  <span>{{addFromNew.shipUnloadTime}} 小时</span>
                </el-form-item>
                <el-form-item label="封航承担比例:" prop="closureRate" class="NOcommon">
                  <span>{{addFromNew.closureRate}} %</span>
                </el-form-item>
                <el-form-item label="受载期限:" prop="loadTime" class="NOcommon">
                  <span>{{dateFormatUtil("yyyy-MM-dd", addFromNew.loadTime)}}</span>
                </el-form-item>
                <el-form-item label="定金金额:" prop="earnestMoney" class="NOcommon">
                  <span>{{addFromNew.earnestMoney}} 元</span>
                </el-form-item>
                <el-form-item label="起始港口:" prop="deliverAddress" class="NOcommon">
                  <span>{{addFromNew.deliverAddress}}</span>
                </el-form-item>
                <el-form-item class="NOcommon" v-if="addFromNew.receiveAddressList && addFromNew.receiveAddressList.length != 0"  v-for="(item, index) in addFromNew.receiveAddressList" :key="index" :label="'目的港口' + (index+1) + ':'" prop="receivingAddressName">
                  <span>{{item.addressName}}</span>
                </el-form-item>
                <el-form-item v-else label="目的港口:" prop="receivingAddressName" class="NOcommon">
                  <span>-</span>
                </el-form-item>
              </div>
            </div>
            <!-- <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>船舶图片</span>
              </h4>
                 <el-image
                 v-for="(item,index) in loadingImgs" :src="item" :key="index"
                  style="width: 260px; height: 200px"
                  :preview-src-list="getSrcList(index,loadingImgs)">
                </el-image>
            </div> -->
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogDetail = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="附件" :close-on-click-modal="false" :close-on-press-escape="false" @close="closeDialog" :visible.sync="imgMark"  width="1100px" center>
      <!-- <div style="margin: 28px 0 0 0;"> -->
         <el-form :inline="true" ref="RZform"  :model="RZform" :rules="rules"
     class="demo-form-inline jiaoyan" label-width="90px" size="mini">
       <div class="inpBox">
            <!-- <div class="imgBox">
            <el-upload
              action="/stock/sBill/addFiles"
              ref="upload"
              :headers="header"
              :auto-upload=false
              :multiple=true
              :on-change="imgPreview"
              list-type="picture-card"
              accept="image/*"
              :limit="20"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove" :class="[isAdd?'hidden':'']"
              >
            </el-upload>
            <span style="font-size:12px">最多上传5张，支持jpg、png格式图片</span>
            <el-dialog  title="图片展示" :visible.sync="dialogVisible" center>
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </div> -->
              <div class="addressBox">
                <h4 class="title">
                  <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>合同照片</span>
                </h4>
                <div>
                    <div class="imgBox">
                      <uploadImgs :imgList.sync='contractFiles' :max=5 @remove='remove'></uploadImgs>
                   </div>
                   <h4 v-if="contractTime.length!=0">上传时间:</h4>
                   <h4 style="margin-left:10px; margin-right:20px; display:inline-block" v-for="(item,index) in contractTime" :key="index">{{item}}</h4>
                </div>
              </div>
              <div style="height:20px"></div>
              <hr>
               <div class="addressBox">
                <h4 class="title">
                  <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>码单照片</span>
                </h4>
                <div>
                  <div class="imgBox">
                      <uploadImgs :imgList.sync='wharfFiles' :max=5 @remove='remove'></uploadImgs>
                   </div>
                  <h4 v-if="contractTime1.length!=0">上传时间:</h4>
                  <h4 style="margin-left:10px; margin-right:20px; display:inline-block" v-for="(item,index) in contractTime1" :key="index">{{item}}</h4>
                </div>
              </div>
      </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="imgMark = false" size='mini' >取消</el-button>
        <el-button type="primary" size="mini" @click="addSave('RZform')" >确定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { cShipInfoList, sAddressList, getShipIdAndNameList, shipContractAdd, shipContractUpdate,
  logicDeleteShipContract, getBaseInfoList, shipContractDetail, getContractAddressList, uploadImage,
  getFileListByContractId, getShipFileList, deleteImage, getContractPdfForBusinessNo, getShipTransportNoByContractId,
  cShipInfoDetail } from '@/api/shipping'
import { sCustomerList } from '@/api/newCrm'
import { emptyFn, dateTimeFormat, dateFormatUtil } from '@/utils/util'
import uploadImgs from '@/views/shipping/contractManagement/contractImg.vue'
import { compressImages } from '@/utils/compressImages'
export default {
  components: {
    uploadImgs
  },
  data () {
    return {
      priceUnitList: [
        { name: '元/吨', value: '1' },
        { name: '元', value: '2' }
      ],
      demurrageRateUnit: [
        { name: '元/天/吨', value: '1' },
        { name: '元/天', value: '2' }
      ],
      CZList: [
        { name: '中物唐山曹妃甸区物流有限责任公司', value: '1' },
        { name: '中物(北京)物流信息服务有限公司唐山曹妃甸分公司', value: '2' }
      ],
      ContractFormulation: [
        { name: '甲方', value: '1' },
        { name: '乙方', value: '2' }
      ],
      RZform: {
      },
      isAdd: false,
      // pickerOptions: {
      //   disabledDate (time) {
      //     return time.getTime() < Date.now() - 8.64e7
      //   }
      // },
      imgMark: false,
      dialogImageUrl: '',
      contractFiles: [],
      wharfFiles: [],
      SCList: [],
      MTList: [],
      loadingImgs: [],
      pricingMethods: [
        { val: 1, name: '按吨' },
        { val: 2, name: '包船' }
      ],
      addFromNew: {
        receiveAddressList: []
      },
      dialogDetail: false,
      h: 500,
      emptyFn: emptyFn,
      dateFormatUtil: dateFormatUtil,
      dateTimeFormat: dateTimeFormat,
      title: '新建',
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      ids: [],
      loading: false,
      rules: {
        shipMentTime: [
          { required: true, message: '请输入装船期限', trigger: 'blur' }
        ],
        shipUnloadTime: [
          { required: true, message: '请输入卸船期限', trigger: 'blur' }
        ],
        contractWeight: [
          { required: true, message: '请输入重量', trigger: 'blur' }
        ],
        goodsName: [
          { required: true, message: '请输入货名', trigger: 'blur' }
        ],
        contractNo: [
          { required: true, message: '请输入合同编号', trigger: 'blur' }
        ],
        contractDraft: [
          { required: true, message: '请选择合同拟定方', trigger: 'blur' }
        ],
        shipName: [
          { required: true, message: '请选择船舶名称', trigger: 'blur' }
        ],
        leaseName: [
          { required: true, message: '请选择出租人甲方', trigger: 'blur' }
        ],
        tenantryName: [
          { required: true, message: '请选择承租人乙方', trigger: 'blur' }
        ],
        shipDateNo: [
          { required: true, message: '请输入航次号', trigger: 'blur' }
        ],
        deliverAddress: [
          { required: true, message: '请选择起始码头', trigger: 'blur' }
        ],
        receivingAddressName: [
          { required: true, message: '请选择目的码头', trigger: 'blur' }
        ],
        pricingMethod: [
          { required: true, message: '请选择计价方式', trigger: 'blur' }
        ],
        earnestMoney: [
          { required: true, message: '请输入订金金额', trigger: 'blur' }
        ],
        // freightMoney: [
        //   { required: true, message: '请输入合同运费价格', trigger: 'blur' }
        // ],
        contractMinWeight: [
          { required: true, message: '请输入合同保底吨数', trigger: 'blur' }
        ],
        demurrageRate: [
          { required: true, message: '请输入合同滞期费率', trigger: 'blur' }
        ],
        loadTime: [
          { required: true, message: '请选择受载期限', trigger: 'blur' }
        ],
        dealDuration: [
          { required: true, message: '请输入合同约定时长', trigger: 'blur' }
        ],
        closureRate: [
          { required: true, message: '请输入封航承担比例', trigger: 'blur' }
        ]
      },
      addFrom: {
        priceUnit: '元/吨',
        demurrageUnit: '元/天/吨',
        goodsName: '钢材',
        // 是否含税
        tax: false,
        shipName: '',
        closureRate: 50,
        deliverAddressNew: {
          addressName: '',
          id: ''
        },
        region: [
          { receivingAddressName: {
            // addressName: '',
            // id: ''
          } }
        ],
        pricingMethod: 1
      },
      contractTime: [],
      contractTime1: [],
      shipId: '',
      CBNameList: [],
      CBList: [], // 船舶列表
      btnFlg: [],
      msg: {},
      jiagefn: false,
      jiagefn1: false,
      LKcontractSysNo: '',
      btnIdArr: ['00KM060100', '00KM060200', '00KM060300', '00KM060400', '00KM060500', '00KM060600']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/SconsignContract')
    cShipInfoList().then(res => {
      this.CBList = res
    })
    sAddressList({ addressType: 2 }).then(res => {
      this.MTList = res
    })
    getShipIdAndNameList().then(res => {
      this.CBNameList = res
    })
    sCustomerList({ tenantCode: localStorage.getItem('tenantCode') }).then(res => {
      this.SCList = res
      console.log(res)
    })
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    lookFn () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 1) {
        this.$alert('只能操作一条！', '系统提示')
      } else {
        this.ids = []
        selectData.some((item, index) => {
          this.$set(this, 'LKcontractSysNo', item.contractSysNo)
          getContractPdfForBusinessNo({ source: 7, businessNo: this.LKcontractSysNo }).then(res => {
            this.$router.push({
              name: 'Pdf',
              query: { path: res }
            })
          }).catch(error => {
            this.$message({
              message: error.message,
              type: 'error'
            })
          })
        })
      }
    },
    gaichange () {
      if (this.addFrom.taxPrice) {
        this.jiagefn = true
      } else {
        this.jiagefn = false
      }
      if (this.addFrom.freightMoney) {
        this.jiagefn1 = true
      } else {
        this.jiagefn1 = false
      }
    },
    taxChange () {
      this.$set(this.addFrom, 'taxPrice', '')
      // 2022.7.29
      if (this.addFrom.taxPrice) {
        this.jiagefn = true
      } else {
        this.jiagefn = false
      }
    },
    taxChange1 () {
      if (this.addFrom.taxPrice) {
        this.$set(this.addFrom, 'tax', true)
        this.jiagefn = true // 2022.7.29
      } else {
        this.$set(this.addFrom, 'tax', false)
        this.jiagefn = false // 2022.7.29
      }
    },

    // 获取船舶信息
    shipNameFn () {
      if (this.addFrom.shipName) {
        // const loading = this.$loading({
        //   lock: true,
        //   text: '正在处理...'
        // })
        cShipInfoDetail({
          shipName: this.addFrom.shipName
        }).then(res => {
          // loading.close()
          this.msg = res.cShipInfo
          this.$set(this.addFrom, 'shipName', this.msg.shipName)
          // this.$set(this.addFrom, 'shipDateNo', this.msg.shipNo)
          this.$set(this.addFrom, 'shipFullDisplacement', this.msg.fullDisplacement)
          this.$set(this.addFrom, 'shipNoLoadDisplacement', this.msg.noLoadDisplacement)
          this.$set(this.addFrom, 'shipTotalLength', this.msg.totalLength)
          this.$set(this.addFrom, 'shipReferenceCapacity', this.msg.referenceCapacity)
          this.$set(this.addFrom, 'shipLength', this.msg.length)
          this.$set(this.addFrom, 'shipWarehouseQuantity', this.msg.warehouseQuantity)
          this.$set(this.addFrom, 'shipWidth', this.msg.width)
          this.$set(this.addFrom, 'shipFullDraft', this.msg.fullDraft)
          // this.addFrom = {
          //   shipName: this.msg.shipName,
          //   shipDateNo: this.msg.shipNo,
          //   shipFullDisplacement: this.msg.fullDisplacement,
          //   shipNoLoadDisplacement: this.msg.noLoadDisplacement,
          //   shipTotalLength: this.msg.totalLength,
          //   shipReferenceCapacity: this.msg.referenceCapacity,
          //   shipWarehouseQuantity: this.msg.warehouseQuantity,
          //   shipLength: this.msg.length,
          //   shipWidth: this.msg.width,
          //   shipFullDraft: this.msg.fullDraft
          // }
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error'
            // onClose () {
            //   loading.close()
            // }
          })
        })
      }
    },
    // 起始港改变
    qishiChange (e) {
      // console.log(this.addFrom.region.length)
      let flag = this.addFrom.region.some(item => item.receivingAddressName && item.receivingAddressName.addressName == e)
      if (flag) {
        this.$alert('起始码头与目的码头不能相同', '系统提示')
        this.$set(this.addFrom, 'deliverAddress', null)
      }

      // console.log(this.addFrom.region)
    },
    // 目的港改变
    mudiChange (e, index1) {
      let flag = this.addFrom.region.some((item, n) => {
        if (index1 != n) {
          return item.receivingAddressName && item.receivingAddressName.addressName == e.addressName
        }
      })
      if (flag) {
        this.$alert('该目的码头已存在', '系统提示')
        this.$set(this.addFrom.region, index1, { receivingAddressName: { addressId: e.id, addressName: e.addressName } })
        return
      }
      // console.log(e)
      // console.log(index1)
      // console.log(this.addFrom.deliverAddress)

      if (e.addressName == this.addFrom.deliverAddress) {
        this.$alert('起始码头与目的码头不能相同', '系统提示')
        this.$set(this.addFrom.region, index1, { receivingAddressName: { addressId: e.id, addressName: e.addressName } })
        console.log(this.addFrom.region.index1)
      }
    },

    // // 图片上传
    // handleRemove (file, fileList) {
    //   console.log(file, fileList)
    //   this.imgList = fileList
    //   if (fileList.length < 5) {
    //     this.isAdd = false
    //   }
    // },
    // imgPreview (file, fileList) {
    //   console.log(file, fileList)
    //   let fileName = file.name
    //   let regex = /(.jpg|.jpeg|.png)$/
    //   if (regex.test(fileName.toLowerCase())) {
    //     this.imgList = fileList
    //     if (fileList.length < 5) {
    //       this.isAdd = false
    //     } else {
    //       this.isAdd = true
    //     }
    //   } else {
    //     fileList.pop()
    //     this.$alert('请选择图片文件图', '系统提示')
    //     return false
    //   }
    // },
    // handlePictureCardPreview (file) {
    //   this.dialogImageUrl = file.url
    //   this.dialogVisible = true
    // },
    // },
    imgFn (row) {
      // this.imgMark = true
      // this.contractFiles = []
      // this.wharfFiles = []
      this.$set(this.RZform, 'shipContractId', row.id)
      getFileListByContractId({ contractId: row.id }).then(res => {
        console.log(res)
        res.contractImageList.forEach((item, index) => {
          this.$set(this.contractTime, index, dateFormatUtil('yyyy-MM-dd hh:ii:ss', item.createTime))
          this.$set(this.contractFiles, index, { status: 'ready', url: item.fileUrlOSS, id: item.id })
        })
        res.wharfImageList.forEach((item, index) => {
          this.$set(this.contractTime1, index, dateFormatUtil('yyyy-MM-dd hh:ii:ss', item.createTime))
          this.$set(this.wharfFiles, index, { status: 'ready', url: item.fileUrlOSS, id: item.id })
        })
        this.imgMark = true
      })
    },
    // 点击凭证放大
    getSrcList (index, arr) {
      return arr.slice(index).concat(arr.slice(0, index))
    },
    // 删除图片
    remove (file, index) {
      // this.RZform.delFileIds.push(file.id)
      this.contractTime.splice(index, 1)
      this.contractTime1.splice(index, 1)
      file.id && deleteImage({ id: file.id }).then(res => {
        this.$message({
          message: '删除成功！',
          type: 'success'
        })
      })
    },
    addSave (formName) {
      if (this.contractFiles.length == 0 && this.wharfFiles.length == 0) {
        this.$alert('请上传合同照片或码单照片！', '系统提示')
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let imgfile = new FormData()
          imgfile.set('params', JSON.stringify(this.RZform))
          let that = this
          let arr = []
          let arr1 = []
          console.log(this.contractFiles)

          this.contractFiles.forEach(item => {
            if (!item.id) {
              arr.push(item)
            }
          })
          this.wharfFiles.forEach(item => {
            if (!item.id) {
              arr1.push(item)
            }
          })
          if (arr.length == 0 && arr1.length == 0) {
            this.imgMark = false
            return
          }
          compressImages(arr, {
            width: 1000
          }).then(result => {
            console.log(result, '33')
            result.forEach(item => {
              imgfile.append('contractFiles', item)
            })
            compressImages(arr1, {
              width: 1000
            }).then(result => {
              console.log(result)
              result.forEach(item => {
                imgfile.append('wharfFiles', item)
              })
              that.save1(imgfile)
            })
          })
        }
      })
    },
    save1 (data) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      uploadImage(data).then(res => {
        loading.close()
        this.$message({
          message: '上传成功！',
          type: 'success'
        })
        this.imgMark = false
        this.getList(this.searchFrom)
        // this.$parent.getList()
        // sShipRecordList({ shipDateId: this.rowData.id }).then(res => {
        //   this.RZList = res.list
        // })
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    add () {
      // console.log(this.addFrom.region)
      this.addFrom.region.push({
        receivingAddressName: ''
        // index1: this.addFrom.region.index1++,
        // receivingAddressIdOne: this.addFrom.region.receivingAddressIdOne
      })
    },
    deleteItem (index1) {
      this.addFrom.region.splice(index1, 1)
    },
    // detailFn (row) {
    //   this.$router.push({ name: 'details', query: { id: row.id } })
    // },
    // 详情
    detailFn (row) {
      this.title = '合同详情'
      this.dialogDetail = true
      shipContractDetail({ id: row.id }).then(res => {
        this.addFromNew = res
        this.$set(this, 'shipId', this.addFromNew.shipId)
        getShipTransportNoByContractId({ shipContractId: row.id }).then(res => {
          this.$set(this.addFromNew, 'shipTransportNo', res.shipTransportNo)
        })
        getContractAddressList({ shipContractId: row.id }).then(res => {
          this.addFromNew.receiveAddressList = res.receiveAddressList
          this.$set(this.addFromNew, 'deliverAddress', res.deliverAddressList[0].addressName)
        })
        getShipFileList({ shipId: this.shipId }).then(res => {
          this.loadingImgs = []
          res.forEach(item => {
            this.loadingImgs.push(item.fileUrlOSS)
          })
        })
      })
    },
    // contractFn () {
    //   getContractPdfForBusinessNo({ source: 7, businessNo: this.addFromNew.contractSysNo }).then(res => {
    //     this.$router.push({
    //       name: 'Pdf',
    //       query: { path: res }
    //     })
    //   }).catch(error => {
    //     this.$message({
    //       message: error.message,
    //       type: 'error'
    //     })
    //   })
    //   //  else {
    //   //   this.$alert('暂无合同', '系统提示')
    //   // }
    // },

    // 选择船名
    // shipNameChange () {
    //   this.$set(this.addFrom, 'shipId', this.addFrom.shipNameO.id)
    // },
    // shipNameChange () {
    //   this.$set(this.addFrom, 'deliverAddress', this.addFrom.deliverAddressNew.deliverAddress)
    // },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      getBaseInfoList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    effectiveTime () {
      if (this.addFrom.closureRate > 100) {
        this.$alert('封航承担比例限制0~100！', '系统提示')
      }
    },
    // 添加
    addRegion () {
      this.title = '新建合同'
      this.jiagefn = false // 2
      this.jiagefn1 = false // 2
      this.dialogVisible = true
      this.isAdd = true
      this.$set(this.addFrom, 'contractNo', 'ZW' + dateFormatUtil('yyyyMMddhhii', (new Date())))
    },
    editFn (row) {
      console.log(row)
      this.title = '修改合同'
      this.jiagefn = false // 2
      this.jiagefn1 = false // 2
      // this.addFrom = { ...row }
      shipContractDetail({ id: row.id }).then(res => {
        this.addFrom = res
        // if (this.addFrom.taxPrice) {
        //   this.$set(this.addFrom, 'tax', true)
        // } else {
        //   this.$set(this.addFrom, 'tax', false)
        //   this.$set(this.addFrom, 'taxPrice', '')
        // }

        // 2022.7.29
        if (this.addFrom.taxPrice) {
          this.jiagefn = true
        } else {
          this.jiagefn = false
        }
        if (this.addFrom.freightMoney) {
          this.jiagefn1 = true
        } else {
          this.jiagefn1 = false
        }

        this.$set(this.addFrom, 'goodsName', '钢材')
        this.$set(this.addFrom, 'loadTime', dateFormatUtil('yyyy-MM-dd', this.addFrom.loadTime))
        if (this.addFrom.contractTime) {
          this.$set(this.addFrom, 'contractTime', dateFormatUtil('yyyy-MM-dd', this.addFrom.contractTime))
        }
        getContractAddressList({ shipContractId: row.id }).then(res => {
          this.$set(this.addFrom, 'deliverAddress', res.deliverAddressList[0].addressName)
          console.log(res.receiveAddressList)
          res.receiveAddressList.forEach((element, index) => {
            console.log(this)

            console.log(this.addFrom)
            this.$set(this.addFrom, 'region', this.addFrom.region || [])
            // console.log(this.addFrom.region)
            this.$set(this.addFrom.region, index, { receivingAddressName: {} })
            this.$set(this.addFrom.region[index], 'receivingAddressName', {
              addressName: element.addressName.toString(),
              id: element.addressId
            })
            this.$forceUpdate()
            console.log(this.addFrom.region)
          })
        })
      })
      this.isAdd = false
      this.dialogVisible = true
    },
    saveFn (formName, n) {
      if (!this.addFrom.taxPrice && !this.addFrom.freightMoney) {
        this.$alert('价格/含税价格，至少填一个，二者只能选一个填写！', '系统提示')
        return
      }
      if (this.addFrom.leaseName) {
        this.addFrom.leaserTenantId = this.SCList.find(item1 => item1.custerName === this.addFrom.leaseName).custerCode
      }
      if (this.addFrom.shipName) {
        this.addFrom.shipId = this.CBNameList.find(item1 => item1.shipName === this.addFrom.shipName).id
      }
      if (this.addFrom.deliverAddress) {
        this.addFrom.addressId = this.MTList.find(item1 => item1.addressName === this.addFrom.deliverAddress).id
      }

      let addForm = {
        shipContract: { ...this.addFrom },
        receiveAddressList: this.addFrom.region.map((item) => {
          return { addressName: item.receivingAddressName.addressName, addressId: item.receivingAddressName.id }
        }),
        deliverAddress: { addressName: this.addFrom.deliverAddress, addressId: this.addFrom.addressId }
      }
      console.log(addForm, 'addForm')
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (this.isAdd) {
            if (n == '1') {
              shipContractAdd(addForm).then(res => {
                loading.close()
                this.$message({
                  message: '添加成功',
                  type: 'success'
                })
                this.dialogVisible = false
                this.getList(this.searchFrom)
              }).catch(error => {
                this.$message({
                  showClose: true,
                  message: error.message,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
            } else {
              shipContractAdd(addForm).then(res => {
                loading.close()
                this.$message({
                  message: '添加成功',
                  type: 'success'
                })
                this.dialogVisible = false
                this.getList(this.searchFrom)
                getContractPdfForBusinessNo({ source: 7 }).then(res => {
                  this.$router.push({
                    name: 'Pdf',
                    query: { path: res }
                  })
                }).catch(error => {
                  this.$message({
                    message: error.message,
                    type: 'error'
                  })
                })
              }).catch(error => {
                this.$message({
                  showClose: true,
                  message: error.message,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
              // getContractPdfForBusinessNo({ source: 7, businessNo: this.addFromNew.contractSysNo }).then(res => {
              //   this.$router.push({
              //     name: 'Pdf',
              //     query: { path: res }
              //   })
              // }).catch(error => {
              //   this.$message({
              //     message: error.message,
              //     type: 'error'
              //   })
              // })
            }
          } else {
            if (n == '1') {
              shipContractUpdate(addForm).then(res => {
                loading.close()
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                this.dialogVisible = false
                this.getList(this.searchFrom)
              }).catch(error => {
                this.$message({
                  showClose: true,
                  message: error.message,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
            } else {
              shipContractUpdate(addForm).then(res => {
                loading.close()
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                this.dialogVisible = false
                this.getList(this.searchFrom)
                getContractPdfForBusinessNo({ source: 7 }).then(res => {
                  this.$router.push({
                    name: 'Pdf',
                    query: { path: res }
                  })
                }).catch(error => {
                  this.$message({
                    message: error.message,
                    type: 'error'
                  })
                })
              }).catch(error => {
                this.$message({
                  showClose: true,
                  message: error.message,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
              // getContractPdfForBusinessNo({ source: 7, businessNo: this.addFromNew.contractSysNo }).then(res => {
              //   this.$router.push({
              //     name: 'Pdf',
              //     query: { path: res }
              //   })
              // }).catch(error => {
              //   this.$message({
              //     message: error.message,
              //     type: 'error'
              //   })
              // })
            }
          }
        } else {
          return false
        }
      })
    },
    // saveFn (formName) {
    //   if (this.addFrom.leaseName) {
    //     this.addFrom.leaserTenantId = this.SCList.find(item1 => item1.custerName === this.addFrom.leaseName).custerCode
    //   }
    //   if (this.addFrom.shipName) {
    //     this.addFrom.shipId = this.CBNameList.find(item1 => item1.shipName === this.addFrom.shipName).id
    //   }
    //   if (this.addFrom.deliverAddress) {
    //     this.addFrom.addressId = this.MTList.find(item1 => item1.addressName === this.addFrom.deliverAddress).id
    //   }

    //   let addForm = {
    //     shipContract: { ...this.addFrom },
    //     receiveAddressList: this.addFrom.region.map((item) => {
    //       return { addressName: item.receivingAddressName.addressName, addressId: item.receivingAddressName.id }
    //     }),
    //     deliverAddress: { addressName: this.addFrom.deliverAddress, addressId: this.addFrom.addressId }
    //   }
    //   console.log(addForm, 'addForm')
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       const loading = this.$loading({
    //         lock: true,
    //         text: '正在处理...'
    //       })
    //       if (this.isAdd) {
    //         shipContractAdd(addForm).then(res => {
    //           loading.close()
    //           this.$message({
    //             message: '添加成功',
    //             type: 'success'
    //           })
    //           this.dialogVisible = false
    //           this.getList(this.searchFrom)
    //         }).catch(error => {
    //           this.$message({
    //             showClose: true,
    //             message: error.message,
    //             type: 'error',
    //             onClose () {
    //               loading.close()
    //             }
    //           })
    //         })
    //       } else {
    //         shipContractUpdate(addForm).then(res => {
    //           loading.close()
    //           this.$message({
    //             message: '修改成功',
    //             type: 'success'
    //           })
    //           this.dialogVisible = false
    //           this.getList(this.searchFrom)
    //         }).catch(error => {
    //           this.$message({
    //             showClose: true,
    //             message: error.message,
    //             type: 'error',
    //             onClose () {
    //               loading.close()
    //             }
    //           })
    //         })
    //       }
    //     } else {
    //       return false
    //     }
    //   })
    // },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        logicDeleteShipContract({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    },
    closeDialog () {
      this.addFrom = {
        priceUnit: '元/吨',
        demurrageUnit: '元/天/吨',
        goodsName: '钢材',
        // 是否含税
        tax: false,
        closureRate: 50,
        deliverAddressNew: {
          addressName: '',
          id: ''
        },
        region: [
          // { receivingAddressName: '' }
          { receivingAddressName: {
            addressName: '',
            id: ''
          } }
        ],
        pricingMethod: 1
      }
      this.RZform = {}
      this.contractFiles = []
      this.wharfFiles = []
      this.contractTime = []
      this.contractTime1 = []
      // this.$refs.table.clearSelection()
      if (this.$refs.addFrom) {
        this.$refs.addFrom.clearValidate()
      }

      this.flag = false
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
/deep/.inpBox2 .el-date-editor .el-input__inner {
    width: 150px;
}
.inpBox1 .el-date-editor{
  width: 350px!important;
}
.detail /deep/.el-form-item__content{
  width: 195px;
}
i {
  font-size: 16px;
  color: #0c46a2;
}
.detailsTitle1 {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: justify;
    /* justify-content: space-between; */
    padding:10px;
    margin-left: 10px;
    border-bottom: 1px solid #dcdfe6;
    margin-bottom: 20px;
}
.detailsTitle1 h4 {
    margin: 0;
    font-size: 20px;
    color: #333;
    padding-bottom: 10px;
    margin-right: 40px;
    /* border-bottom: 2px solid #0c46a2; */
}
/deep/.NOcommon .el-form-item__label:before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
}
/deep/.el-input.is-disabled .el-input__inner {
    color: #333333;
    cursor: not-allowed;
}
/deep/.disabled .el-input__inner {
    background: #dcedff;
    cursor: not-allowed;
}
/deep/.inpBox3 .el-input__inner {
    width: 80px;
}
/deep/.inpBox4 .el-input__inner {
    width: 90px;
}
.jiage .el-form-item__content {
  position: relative;
  .danwei1 {
    position: absolute;
    right: -10px;
    color: white;
    // padding: 7px 4px;
  }
}
</style>
